import { ExpandMore, HighlightOffOutlined } from "@mui/icons-material";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import CBConsent from "./CBConsent";
import { CBConsentCompanyCode, CBCreationOfProps, CBOmissionType } from "../../types";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { useCallback } from "react";
import CBConsentNew from "./CBConsentNew";

interface CBConsentsAccordionProps extends CBCreationOfProps {
    //isExpanded: boolean,
    index: number,
    consent: any,
    //onRemove: (event: SyntheticEvent, index: number) => void
}
const CBConsentsAccordion = ({
    creationOf,
    index,
    consent
}: CBConsentsAccordionProps) => {

    const getCheckboxLabel = useCallback((consent: any) => {
        let label: string = consent?.termCondType;

        // if(!!consent?.companyCode && consent.companyCode == CBConsentCompanyCode.DRIVALIA_FRANCE) {
        //     if(!!consent.communicationChannel && consent.communicationChannel != CBOmissionType.OMISSION_DASH) {
        //         label += " - " + consent.communicationChannel;
        //     }
        // }

        if (!!consent?.companyCode) {
            if (!!consent.communicationChannel && consent.communicationChannel != CBOmissionType.OMISSION_DASH) {
                label += "";
            }
        }

        return label;

    }, []);

    return (
        <Accordion>
            <AccordionSummary expandIcon={<ExpandMore />}>
                <Grid container alignItems="center" width={"99%"}>
                    <Grid item md={6} xs={6}>
                        {(consent.result == false) ?
                            <Stack direction={"row"} spacing={1} alignItems="center">
                                <HighlightOffOutlined fontSize="small" color="primary" sx={{ margin: 1 }} />
                                <Box>{getCheckboxLabel(consent)}</Box>
                            </Stack>
                            :
                            <FormControlLabel
                                key={`consent-result-title-${consent.id}`}
                                label={getCheckboxLabel(consent)}
                                labelPlacement="end"
                                style={{ marginLeft: 0 }}
                                control={
                                    <Checkbox
                                        id={`conset-result-title-${consent.id}`}
                                        checked={consent.result ?? false}
                                        disableRipple
                                    />
                                }
                            />
                        }
                    </Grid>
                </Grid>
            </AccordionSummary>
            <AccordionDetails>
                <CBConsent 
                    index={index}
                    creationOf={creationOf}
                />
            </AccordionDetails>
        </Accordion>
    )

}

export default CBConsentsAccordion;